<template>
  <div>
    <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
      <div>
        <a-descriptions :column="1">
          <a-descriptions-item label="Mã">
            {{ typeWorkLeave.code }}
          </a-descriptions-item>
          <a-descriptions-item label="Loại nghỉ phép">
            {{ typeWorkLeave.title }}
          </a-descriptions-item>
          <a-descriptions-item label="Số ngày nghỉ tối đa">
            {{ typeWorkLeave.limit }}
          </a-descriptions-item>
          <a-descriptions-item label="Chế độ">
            {{ typeWorkLeave.benefit }}
          </a-descriptions-item>
          <a-descriptions-item label="Tạo bởi">
            {{
              typeWorkLeave.author &&
              (typeWorkLeave.author.fullname || typeWorkLeave.username)
            }}
          </a-descriptions-item>
          <a-descriptions-item label="Ngày tạo">
            {{ typeWorkLeave.createdAt | formatDateHour }}
          </a-descriptions-item>
          <a-descriptions-item label="Cập nhật lần cuối">
            {{ typeWorkLeave.updatedAt | formatDateHour }}
          </a-descriptions-item>
        </a-descriptions>

        <a-alert type="info" v-if="typeWorkLeave.description">
          <div slot="message">Mô tả</div>
          <div slot="description" v-html="typeWorkLeave.description"></div>
        </a-alert>
      </div>
    </a-skeleton>
  </div>
</template>
<script>
import query from "../constant/query";
export default {
  props: { idTypeWorkLeave: { type: String, required: true } },
  data() {
    return {
      typeWorkLeave: {},
      loading: false,
    };
  },
  methods: {
    onGetTypeWorkLeave() {
      this.loading = true;
      this.$apollo
        .query({
          query: query.getTypeWorkLeave,
          variables: { id: this.idTypeWorkLeave },
        })
        .then(({ data }) => {
          this.loading = false;
          if (data?.getTypeWorkLeave?.id) {
            this.typeWorkLeave = { ...data.getTypeWorkLeave };
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Get Item Error!",
          });
          console.log("Lấy chi tiết loại nghỉ phép không thành công", error);
        });
    },
  },
  created() {
    this.onGetTypeWorkLeave();
  },
};
</script>
<style lang="css" scoped></style>
